import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SvgComponent } from '@components/svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { CtaButton } from '@components/button-cta.component';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [SvgComponent, TranslateModule, CtaButton],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-3"
    >
      <div
        class="rounded flex flex-col bg-white w-full h-full max-w-xl max-h-96"
      >
        <div class="w-full flex mt-4">
          <app-svg
            [svgPath]="'assets/svg/prompt.svg'"
            class="block w-fit mx-auto"
            height="70"
            width="70"
          />
        </div>

        <div class="w-full mt-4">
          <h2 class="text-xl fg-noir-1 font-bold text-center px-4">
            {{ title | translate }}
          </h2>
        </div>

        <div class="w-full flex-1 px-6 py-4 overflow-auto">
          <div
            [innerHTML]="description | translate"
            class="text-center text-gray-700"
          ></div>
        </div>

        <div class="w-full flex gap-4 px-6 pb-6">
          @if (cancelButtonText.length) {
            <app-button-cta
              svgName="chevron_left"
              iconType="material"
              type="grey"
              (onClick)="onCancel()"
              label="{{ cancelButtonText | translate }}"
              class="flex-1"
            />
          }

          @if (keepButtonText) {
            <app-button-cta
              svgName="chevron_right"
              iconType="material"
              type="grey"
              (onClick)="onKeep()"
              label="{{ keepButtonText | translate }}"
              class="flex-1"
            />
          }

          <app-button-cta
            (onClick)="onConfirm()"
            class="flex-1"
            iconType="material"
            label="{{ confirmButtonText | translate }}"
            svgName="check_circle"
            type="green"
          />
        </div>
      </div>
    </div>
  `,
})
export class ConfirmationModalComponent {
  onConfirm: () => void = () => {};
  onCancel: () => void = () => {};
  onKeep: () => void = () => {};

  cancelButtonText: string = '';
  confirmButtonText: string = '';
  keepButtonText?: string;
  description: string = '';
  title: string = '';
}
